import { chain } from 'lodash';
import { FormCombination, FormWordGroup } from '../models/ComboFormState';

export const getCombinationName = (cc: FormCombination, wordGroups: FormWordGroup[]): string =>
  chain(cc.wordGroups)
    .orderBy((CCwg) => CCwg.order, ['asc'])
    .map((CCwg, index) => {
      const name = wordGroups.find((wg) => wg.id === CCwg.id).name;
      if (cc.removeSpacing === 0) {
        const separator = index === cc.wordGroups.length - 1 ? '' : ' ';
        return `${name}${separator}`;
      } else {
        const separator =
          index === cc.removeSpacing - 1 || index === cc.wordGroups.length - 1 ? '' : ' ';
        return `${name}${separator}`;
      }
    })
    .join('')
    .value();
